import { render, staticRenderFns } from "./Detail_Estimation.vue?vue&type=template&id=2d27ecdd&scoped=true&"
import script from "./Detail_Estimation.vue?vue&type=script&lang=js&"
export * from "./Detail_Estimation.vue?vue&type=script&lang=js&"
import style0 from "./Detail_Estimation.vue?vue&type=style&index=0&id=2d27ecdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27ecdd",
  null
  
)

export default component.exports